import { DATA_SERVICE_BASE_URL } from '../ApiService';
import { fetchWithAuth } from '../AuthService';

/**
 * Student Progress API — user-facing endpoints that return the authenticated user's own data.
 * No admin role required.
 */
export const StudentProgressApi = {
  /**
   * Get the current user's learning profile (sessions, quiz scores, study time, learning style, etc.).
   */
  getMyProfile: async () => {
    const response = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/student/progress/profile`);
    if (!response.ok) {
      throw new Error(`Student profile failed: ${response.status}`);
    }
    return response.json();
  },

  /**
   * Get the current user's recent activity (event breakdown + daily timeline).
   * @param {number} [days=30] - Number of days to look back
   */
  getMyActivity: async (days = 30) => {
    const params = new URLSearchParams({ days: String(days) });
    const response = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/student/progress/activity?${params}`);
    if (!response.ok) {
      throw new Error(`Student activity failed: ${response.status}`);
    }
    return response.json();
  },

  /**
   * Get the current user's learning sessions (paginated).
   * @param {Object} params
   * @param {string} params.from - ISO timestamp
   * @param {string} params.to - ISO timestamp
   * @param {number} [params.page=0]
   * @param {number} [params.pageSize=20]
   */
  getMySessions: async ({ from, to, page = 0, pageSize = 20 }) => {
    const params = new URLSearchParams({ from, to, page: String(page), pageSize: String(pageSize) });
    const response = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/student/progress/sessions?${params}`);
    if (!response.ok) {
      throw new Error(`Student sessions failed: ${response.status}`);
    }
    return response.json();
  }
};
